<template>
	<div class="container-fluid">
		<navigation-admin></navigation-admin>
		<div class="row row-fluid">
			<sidebar-admin></sidebar-admin>
			<section class="col-sm-10 admin-background-shadow overflow">
			<div class="row row-fluid">
				<div class="col-sm-5">
					<admin-form></admin-form>
				</div>
			</div>
			</section>
		</div>
	</div>	
</template>

<script>
import navigationAdmin from '../../components/Admin/Admin-navigation.vue';
import sidebarAdmin from '../../components/Admin/Admin-sidebar.vue';
import adminForm from '../../components/Admin/Admin-form.vue';

export default {
  components: {
    navigationAdmin,
    sidebarAdmin,
    adminForm,
  },
};
</script>


// WEBPACK FOOTER //
// Admin-users-form.vue?17d091e9